/**
 * the no-element is used to eliminate the region without having to deal with `undefined` on the type
 */
export const noEl = globalThis?.document?.createElement('marquee');
